import React, {useState, useRef, useEffect} from 'react';
import Search from './Search';
import Button from "@hig/button";
import Profile from './Profile';
import './style.scss';
import {fetchJson} from "../../utils/util_functions";

export default function NavHeaderTop(props) {

  const [numOfHubs, setNumOfHubs] = useState(0);

  // Sets number of dev hubs that the user has
  useEffect(() => {
    fetchJson(process.env.USER_STATUS).then((json) => {
      setNumOfHubs(json.hubs_count);
    })
  }, []);

  return (
    <div className={`aps__nav-header__top`}>
      <div className={`constrain`}>
        <div className={`aps__logo`} key={`logo`}>
          <a
            data-test-id="aps-logo-header-link"
            data-external-target="aps-logo-header-link"
            href="//aps.autodesk.com/"
            title="Autodesk Platform Services"
            aria-label="Autodesk Platform Services"
          >
            <img
              src="//aps.autodesk.com/static/1.0.0.20250424162325/images/aps-logo--white.svg"
              alt="Autodesk Platform Services"
            />
          </a>
        </div>
        <Search key={`search`}/>
        <div className='aps__nav-header__hub-button-wrapper'>
          <Button
            size="standard"
            title={"Developer hubs"}
            link={'/hubs/'}
            style={{
              backgroundColor: "#000",
              borderColor: "#fff",
              display: numOfHubs > 0 ? 'block' : 'none'
              // display: true ? 'block' : 'none'
            }}
          />
        </div>
        <Profile key={`profile`}/>
      </div>
    </div>
  );
};
